<template>
  <div
    class="accordion"
    data-cy="accordion"
  >
    <ul class="accordion__items">
      <slot />
    </ul>
    <IconsWrapper>
      <IconsSymbolAngleDown />
    </IconsWrapper>
  </div>
</template>

<style lang="scss" scoped>
.accordion__items {
    list-style: none;
    margin: 0;
    padding: 0;
}
</style>
